// Озвучка ответа средствами браузера (W3C Web Speech API, ТЗ 11.2), когда сервер не вернул
// аудио: синтез на сервере не удался или недоступен.

function synthesis(): SpeechSynthesis | null {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) return null;
  if (typeof SpeechSynthesisUtterance === 'undefined') return null;
  return window.speechSynthesis;
}

export function speakWithBrowser(text: string, lang?: string | null): boolean {
  const synth = synthesis();
  if (!synth || !text.trim()) return false;
  synth.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  if (lang) utterance.lang = lang;
  synth.speak(utterance);
  return true;
}

export function stopBrowserSpeech(): void {
  synthesis()?.cancel();
}

export function browserSpeaking(): boolean {
  return synthesis()?.speaking ?? false;
}
